module.exports = __webpack_public_path__ + "img/login_tab04_02.23f88f19.png";